import React from 'react'
import "./home.css"
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper';
import Content from '../content/Content';

export default function Home() {
    return (
        <>
            <div className='home-page'>
                <div className='parallax'>
                    <div>
                        <h1>Winterns</h1>
                        <div>
                            Let us be your guide on<br />your way to <span>win</span>.
                        </div>
                    </div>
                </div>
                <div id='slider' className='slider'>
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        loop={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        modules={[Autoplay, Pagination, Navigation]}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <img src='http://react-responsive-carousel.js.org/assets/1.jpeg' alt='' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src='http://react-responsive-carousel.js.org/assets/2.jpeg' alt='' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src='http://react-responsive-carousel.js.org/assets/3.jpeg' alt='' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src='http://react-responsive-carousel.js.org/assets/4.jpeg' alt='' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src='http://react-responsive-carousel.js.org/assets/5.jpeg' alt='' />
                        </SwiperSlide>
                    </Swiper>
                </div>
                <Content />
            </div>
        </>
    )
}